// external imports
import React from 'react'
import { Select, Option } from 'quark-web'
import { graphql } from 'react'
// local imports
import { QueryRenderer } from '~/components'

const LocaleSelect = props => (
    <QueryRenderer
        query={graphql`
            query LocaleSelectQuery {
                allLocales {
                    edges {
                        node {
                            display
                            code
                        }
                    }
                }
            }
        `}
        render={data =>
            !data ? (
                'loading'
            ) : (
                <Select
                    value={localStorage.getItem('locale')}
                    onChange={val => {
                        // if we are clearing the value
                        if (!val) {
                            localStorage.removeItem('locale')
                        } else {
                            localStorage.setItem('locale', val)
                        }

                        // refresh the view
                        window.location = '/'
                    }}
                >
                    <Option value={null}>English</Option>
                    {data.allLocales.edges.map(({ node: locale }) => (
                        <Option value={locale.code}>{locale.display}</Option>
                    ))}
                </Select>
            )
        }
    />
)

export default LocaleSelect



// WEBPACK FOOTER //
// ./src/views/Root/Nav/LocaleSelect.js